import React, { Component } from "react";
import styled from "styled-components";

// Components
import LandingPageForm from "./LandingPageForm";
import Card from "./Card";
import TrialPeriodOverModal from "../../components/TrialPeriodOverModal";

import "./styles.css";

const HowItWorksHeader = styled.h2`
  margin-top: 60px;
  text-transform: uppercase;
  letter-spacing: 1px;
  font-weight: 400;
  color: black;
`;
const EmphasizedText = styled.span`
  font-style: italic;
  font-weight: 600;
  color: #eb5e28;
`;

class LandingPage extends Component {
  render() {
    return (
      <div>
        {/* Popup for trial period message */}
        <TrialPeriodOverModal />

        {/* Main page content */}
        <LandingPageForm />
        <div class="how-it-works container">
          <HowItWorksHeader>How it works</HowItWorksHeader>
          <div class="card-container">
            <Card
              // iconClass="icofont-map"
              src={"/assets/img/find.png"}
              subHeader="1. Find Trip"
              details="Search for a trip using our easy to use flight search engine."
            />
            <Card
              // iconClass="icofont-air-ticket"
              src={"/assets/img/book.png"}
              subHeader="2. Book Trip"
              details="Book your trip by making a down payment. No credit check."
            />
            <Card
              // iconClass="icofont-pay"
              src={"/assets/img/pay.png"}
              subHeader="3. Complete Payment"
              details={
                <React.Fragment>
                  Pay the remaining balance in biweekly installments{" "}
                  <EmphasizedText>before your departure date.</EmphasizedText>
                </React.Fragment>
              }
            />
            <Card
              // iconClass="icofont-travelling"
              src={"/assets/img/travel.png"}
              subHeader="4. Take Trip"
              // details="When your payments are complete, have a safe trip!"
              // details="Pay off your balance before your departure date and enjoy your trip!
              details="Upon completing your payments, enjoy your trip!"
            />
          </div>
        </div>
      </div>
    );
  }
}

export default LandingPage;



// WEBPACK FOOTER //
// ./src/scenes/LandingPage/index.js